/**=========================================================
 * Module: tools.js
 * Tools Controller
 =========================================================*/

 App.controller("ToolsController", ["$rootScope", "$scope", "$state", "$translate", "$window", "$localStorage", "$timeout", "toggleStateService", "Restangular", "DataService", '$filter', '$sce',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, $sce) 
 {
     
   $scope.page = {
       title: 'sidebar.nav.JOINHTML',
       subTitle: 'sidebar.heading.TOOLS'
   }

   $scope.loadingResponse = false
   let callFile = null

   var callJoinHtml = function(getFile, model){
       model = model || {}
        if($rootScope.files['file'+$scope.joinHtmlForm.model.id+'joinhtml'] && $rootScope.files['file'+$scope.joinHtmlForm.model.id+'joinhtml'].length>0) {
            var file = $rootScope.files['file'+$scope.joinHtmlForm.model.id+'joinhtml'][0]
            if(file.id==callFile && !getFile) return
            callFile = file.id
            if(!$scope.loadingResponse){
                $scope.joinHtmlForm.status = 'notsubmittable'
                $scope.response = {}
                D.fn('joinHtml', getFile ? 'put' : 'post', '', { filename: file.storageUrl, files: model.files })
                    .then(function(response){
                        $scope.loadingResponse = false
                        $timeout(function(){
                            $scope.response = response
                            $scope.response.trusted = $sce.trustAsResourceUrl(response.url)
                            $scope.joinHtmlForm.model.files = response.files
                            $scope.joinHtmlForm.status = ''
                        },10)
                    }).catch(function(err){
                        $scope.loadingResponse = false
                        $timeout(function(){
                            $scope.joinHtmlForm.status = ''
                        },10)
                    })
            }
            $scope.loadingResponse = true
        }
   }

   function array_move(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
        
    }

   $scope.dropped = function(dragEl, dropEl) {
       var idx1 = + (dragEl.substring(1))
       var idx2 = + (dropEl.substring(1))
       array_move($scope.response.files, idx1, idx2)
       $scope.joinHtmlForm.model.files = $scope.response.files
       $scope.$apply(function() { $scope.response.files = [] })
       $timeout(function() {
           $scope.response.files = $scope.joinHtmlForm.model.files
       },100)
   }

   $scope.joinHtmlForm = {
    title: '',
    status: '',
    type: 'file',
    info: $filter('translate')('labels.JOINHTMLINFO'),
    model: {
        id: 'joinhtml_' + new Date().getTime()
    },
    refreshFile: function(data){
        callJoinHtml(false)
    },
    fields: [
        {
            available: true,
            type: 'file',
            name: 'joinhtml',
            canUpload: true,
            noLabel: true,
            inputColumn: 12,
            limit: 1,
            allow: 'zip',
            bucket: $rootScope.bucketName()
        },{
            available: true,
            type: 'hidden',
            name: 'files'
        },
        {
            available: true,
            type: 'submit',
            name: 'empty',
            label: 'labels.JOINHTML',
            labelColumn: 0
        }
    ],
    submit: function(){
        callJoinHtml(true, this.model)
    }

    }
}]);
